import { render, staticRenderFns } from "./TrainReservation.vue?vue&type=template&id=50bfccc8&scoped=true"
import script from "./TrainReservation.vue?vue&type=script&lang=js"
export * from "./TrainReservation.vue?vue&type=script&lang=js"
import style0 from "./TrainReservation.vue?vue&type=style&index=0&id=50bfccc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bfccc8",
  null
  
)

export default component.exports